import React from 'react';

const Subscriptions = () => {
    return (
            <div className=''>
                <h1>Suscripciones</h1>
            </div>
    );
};

export default Subscriptions;
